<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div [ngClass]="{ zonaoculta: loading === true }">
  <app-buttons
    (save)="submit()"
    (close)="closePanel()"
    (discard)="discard()"
    [buttonsWrap]="'panel'"
    [modificar]="modificar"
  ></app-buttons>

  <div class="editor-registro">
    <div class="divForm">
      <form [formGroup]="editAccommodationForm" (ngSubmit)="submit()">
        <div class="form-group">
          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.Codigo || "Código" }}</mat-label>
            <input
              matInput
              formControlName="CodAlojamientoTX"
              maxlength="50"
              (input)="onInputForbiddenSequences($event, 'CodAlojamientoTX')"
            />
            <mat-error *ngIf="validateFields('CodAlojamientoTX')">
              {{ getErrorMessage("CodAlojamientoTX") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{ translation?.Descriptivo || "Descriptivo" }}</mat-label>
            <input
              matInput
              formControlName="DescriptivoTX"
              maxlength="255"
              (input)="onInputForbiddenSequences($event, 'DescriptivoTX')"
            />
            <mat-error *ngIf="validateFields('DescriptivoTX')">
              {{ getErrorMessage("DescriptivoTX") }}
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>{{
              translation?.DescriptivoEsp || "Descriptivo español"
            }}</mat-label>
            <input
              matInput
              formControlName="DescriptivoEspTX"
              maxlength="255"
              (input)="onInputForbiddenSequences($event, 'DescriptivoEspTX')"
            />
            <mat-error *ngIf="validateFields('DescriptivoEspTX')">
              {{ getErrorMessage("DescriptivoEspTX") }}
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</div>
